// @flow

import React from 'react';
import {FormattedMessage} from 'react-intl';

import type {Node} from 'react';

export type ScreenReaderDetailsProps = {
    propertyType: string,
    sleeps?: number,
    bedrooms?: number,
    bathroomsFull?: number,
    bathroomsHalf?: number,
    bathroomsToiletOnly?: number,
    area?: number,
    isMetric?: boolean,
    local?: string
};

export default function ScreenReaderDetails({
    bedrooms,
    propertyType,
    bathroomsFull,
    bathroomsHalf,
    bathroomsToiletOnly,
    sleeps,
    area,
    isMetric,
    local
}: ScreenReaderDetailsProps) {
    return (
        <div className="sr-only">
            <FormattedMessage id="propertyType" defaultMessage="property type">
                {/* istanbul ignore next */
                (txt: Node): Node => (
                    <span>
                        {txt}
                        {propertyType}
                    </span>
                )}
            </FormattedMessage>

            {!!bedrooms && (
                <FormattedMessage
                    id="bedroomsFilterLabel"
                    defaultMessage="bedrooms"
                    values={{bedroomsCount: bedrooms}}
                >
                    {/* istanbul ignore next */
                    (txt: Node): Node => (
                        <span>
                            {bedrooms}
                            {txt}
                        </span>
                    )}
                </FormattedMessage>
            )}

            {!!bathroomsFull && (
                <FormattedMessage
                    id="bathroomsFilterLabel"
                    defaultMessage="bathrooms"
                    values={{bathroomsCount: bathroomsFull}}
                >
                    {/* istanbul ignore next */
                    (txt: Node): Node => (
                        <span>
                            {bathroomsFull}
                            {txt}
                        </span>
                    )}
                </FormattedMessage>
            )}

            {!!bathroomsHalf && (
                <FormattedMessage
                    id="bathroomsHalfLabel"
                    defaultMessage="half bathroom"
                >
                    {/* istanbul ignore next */
                    (txt: Node): Node => (
                        <span>
                            {bathroomsHalf}
                            {txt}
                        </span>
                    )}
                </FormattedMessage>
            )}

            {!!bathroomsToiletOnly && (
                <FormattedMessage
                    id="bathroomsToiletOnlyLabel"
                    defaultMessage="toilet only"
                >
                    {/* istanbul ignore next */
                    (txt: Node): Node => (
                        <span>
                            {bathroomsToiletOnly}
                            {txt}
                        </span>
                    )}
                </FormattedMessage>
            )}

            {!!sleeps && (
                <FormattedMessage id="sleepsLabel" defaultMessage="Sleeps">
                    {/* istanbul ignore next */
                    (txt: Node): Node => (
                        <span>
                            {sleeps}
                            {txt}
                        </span>
                    )}
                </FormattedMessage>
            )}

            {!!area && (
                <FormattedMessage
                    id="areaLabelVerbose"
                    defaultMessage={isMetric ? 'Meters' : 'Square Feet'}
                    values={{METRIC: isMetric}}
                >
                    {/* istanbul ignore next */
                    (txt: Node): Node => (
                        <span>
                            {area.toLocaleString(local, {
                                maximumFractionDigits: 2
                            })}
                            {txt}
                        </span>
                    )}
                </FormattedMessage>
            )}
        </div>
    );
}
